export const timeDifference = (dateStr, t) => {
  // Ensure only milliseconds (3 digits) since JS Date only supports up to ms
  const safeStr = dateStr.replace(/(\.\d{3})\d+$/, "$1");
  const targetDate = new Date(safeStr);
  const now = new Date();

  let diffMs = Math.abs(now.getTime() - targetDate.getTime()); // difference in ms

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30); // rough estimate
  const years = Math.floor(days / 365);

  if (seconds < 60) {
    return t("time.second", { count: seconds });
  } else if (minutes < 60) {
    return t("time.minute", { count: minutes });
  } else if (hours < 24) {
    const remMinutes = minutes % 60;
    return `${t("time.hour", { count: hours })} ${t("time.minute", { count: remMinutes })}`;
  } else if (days < 30) {
    return t("time.day", { count: days });
  } else if (days < 365) {
    return t("time.month", { count: months });
  } else {
    const remMonths = months % 12;
    if (remMonths > 0) {
      return `${t("time.year", { count: years })} ${t("time.month", { count: remMonths })}`;
    }
    return t("time.year", { count: years });
  }
};

export const hasDatePassed = (dateStr) => {
  const safeStr = dateStr.replace(/(\.\d{3})\d+$/, "$1");
  const targetDate = new Date(safeStr);
  return targetDate.getTime() < Date.now();
};
